import { TZDateMini } from '@date-fns/tz';
import { createContext, type Dispatch, type Context } from 'react';

import { getTimezone } from '@dynatrace-sdk/user-preferences';

import type { Timeframe } from '../../../core/types/time.js';
import type {
  CalendarReducerAction,
  CalendarState,
} from '../types/shared-types.js';

/** @internal */
export type CalendarContextProps = {
  onChange?: (value: string | null | Timeframe) => void;
  state: CalendarState;
  dispatch: Dispatch<CalendarReducerAction>;
  readOnly: boolean;
};

// Current date
const today = TZDateMini.tz(getTimezone());

/**
 * @internal
 */
export const initialState: CalendarState = {
  activeDate: today,
  currentView: 'day',
  shouldUpdateFocusFromKeydown: null,
  today,
  type: 'single',
};

/**
 * Calendar context, used to access the state and dispatcher in other components
 * @internal
 */
export const CalendarContext: Context<CalendarContextProps> =
  createContext<CalendarContextProps>({
    state: initialState,
    dispatch: () => null,
    onChange: () => null,
    readOnly: false,
  });
